import { DataPickerUiTemplate, WrapperEntryName } from '@/interfaces';
import dynamic from 'next/dynamic';

export const WrapperEntryMapping: {
  [key in WrapperEntryName]: React.ComponentType<any>;
} = {
  [WrapperEntryName.Company]: dynamic(async () => import('../components/Wrapper/CompanyLogos')),
  [WrapperEntryName.People]: dynamic(async () => import('../components/Wrapper/PeopleWithQuotes')),
  [WrapperEntryName.ContentItem]: dynamic(async () => import('../components/Wrapper/ContentItems')),
  [WrapperEntryName.Market]: dynamic(async () => import('../components/Wrapper/RegionWorldMap')),
  [WrapperEntryName.ThumbnailSection]: dynamic(async () => import('../components/ThumbnailSection')),
};

export const WrapperDataPickerMapping: {
  [key in DataPickerUiTemplate]: React.ComponentType<any>;
} = {
  [DataPickerUiTemplate.Table]: dynamic(async () => import('../components/Wrapper/DataPickerSection/TableSection')),
  [DataPickerUiTemplate.Columns]: dynamic(async () => import('../components/Wrapper/DataPickerSection/ColumnsSection')),
};
